import apiClient from '@/lib/api/apiClient'
import { API_ENDPOINTS } from '@/lib/api/config'
import type { ChecklistTemplateResponse, SaveChecklistPayload } from '../types/services'
import { throwServiceError } from './serviceHelpers'

/** Checklist template. */
export async function getChecklistTemplate(): Promise<ChecklistTemplateResponse> {
  try {
    const response = await apiClient.get<ChecklistTemplateResponse>(
      API_ENDPOINTS.CHECKLIST_TEMPLATE,
    )
    return response.data
  } catch (error) {
    throwServiceError(error, 'Failed to load checklist template.')
  }
}

/** Save applicant checklist. */
export async function saveChecklist(
  applicantId: string | number,
  requestData: SaveChecklistPayload,
): Promise<void> {
  try {
    await apiClient.post(API_ENDPOINTS.SAVE_CHECKLIST(applicantId), requestData)
  } catch (error) {
    throwServiceError(error, 'Failed to save checklist.')
  }
}
